import { render, staticRenderFns } from "./ModuleSettings.vue?vue&type=template&id=282a05b8"
import script from "./ModuleSettings.vue?vue&type=script&lang=js"
export * from "./ModuleSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports